import { Link } from 'react-router-dom';
import {
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import { Button } from 'antd';

/** Shown in place of a profile's body when the record cannot be loaded. */
export default function ProfileErrorState({
  message,
  detail,
  backUrl,
  backLabel,
}) {
  return (
    <div className="m-3 flex flex-1 flex-col items-center justify-center gap-4 rounded-[14px] bg-white p-8 text-center">
      <ExclamationCircleOutlined className="text-4xl text-amber-500" />
      <p className="m-0 max-w-md text-base font-semibold text-zinc-800">
        {message}
      </p>
      {detail && <p className="m-0 max-w-md text-sm text-zinc-500">{detail}</p>}
      <Link to={backUrl}>
        <Button
          className="btn-default btn-default--hover !rounded-[50px]"
          icon={<ArrowLeftOutlined />}
        >
          {backLabel}
        </Button>
      </Link>
    </div>
  );
}
